// FontAwesome Library
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Icons
import {
  faInfoCircle,
  faTimes,
  faPlus,
  faEye,
  faEyeSlash,
  faCheck,
  faExclamationTriangle,
  faBell,
  faCheckCircle,
  faBan,
  faSearch,
} from '@fortawesome/free-solid-svg-icons'


Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(
  faInfoCircle,
  faTimes,
  faPlus,
  faEye,
  faEyeSlash,
  faCheck,
  faExclamationTriangle,
  faBell,
  faCheckCircle,
  faBan,
  faSearch,
)